export const validationReasonMap: Record<number, string> = {
  400: 'Bad request. The file could not be processed.',
  404: 'File not found or unrecognized.',
  409: 'File conflict. The file could not be validated.',
  410: 'Unsupported File Format',
  411: 'Empty File',
  413: 'Corrupt or password-protected file.',
  416: 'Transformation failure. The file could not be converted.',
  499: 'Validation error. The file could not be validated.',
  500: 'Internal server error. Validation could not be completed.',
  501: 'Validation service unavailable.',
};

export const getValidationReason = (statusCode: number): string =>
  validationReasonMap[statusCode] ?? 'Validation failed.';
